import { getI18nInstance } from '@/i18n';
import { ROLES } from '@/models/User';

const WertelistenIndex = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/index.vue');
const MailingListIndex = () =>
    import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/mailing_list/index.vue');
const TagGroupIndex = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/tag_group/index.vue');
const TagGroupEdit = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/tag_group/_id.vue');
const TagIndex = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/tag/index.vue');
const TagEdit = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/tag/_id.vue');
const CategoryIndex = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/category/index.vue');
const WeblinkIndex = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/weblink/index.vue');
const GenreGroupIndex = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/genre_group/index.vue');
const GenreGroupEdit = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/genre_group/_id.vue');
const EventfrogRubricIndex = () =>
    import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/eventfrog_rubric/index.vue');
const OrganizerGroupIndex = () =>
    import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/organizer_group/index.vue');
const OrganizerGroupEdit = () =>
    import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/organizer_group/_id.vue');
const RegionIndex = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/region/index.vue');
const RegionEdit = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/region/_id.vue');
const ZipIndex = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/zip/index.vue');
const ZipEdit = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/zip/_id.vue');
const DossierIndex = () => import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/dossier/index.vue');
const ScheduleStatusIndex = () =>
    import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/schedule_status/index.vue');
const TargetAudienceIndex = () =>
    import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/target_audience/index.vue');

const OccupancyOverview = () => import(/* webpackChunkName: "admin" */ '@/views/auth/occupancy/overview.vue');
const AddressDuplicatesIndex = () =>
    import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/address_duplicates/index.vue');
const EventDuplicatesIndex = () =>
    import(/* webpackChunkName: "admin" */ '@/views/auth/wertelisten/event_duplicates/index.vue');

export default [
    {
        path: '/occupancy/overview',
        name: 'occupancy_overview',
        component: OccupancyOverview,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN],
            title: () => getI18nInstance().t('occupancy_overview'),
        },
    },
    {
        path: '/address_duplicates',
        name: 'address_duplicates',
        component: AddressDuplicatesIndex,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN],
            title: () => getI18nInstance().t('addr_dups'),
        },
    },
    {
        path: '/event_duplicates',
        name: 'event_duplicates',
        component: EventDuplicatesIndex,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN],
            title: () => getI18nInstance().t('event_dups'),
        },
    },
    {
        path: '/wertelisten',
        name: 'wertelisten',
        component: WertelistenIndex,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN],
            title: () => getI18nInstance().t('wertelisten'),
        },
        children: [
            {
                path: 'mailing_list',
                name: 'wl_mailing_list',
                component: MailingListIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('mailing_listen'),
                },
            },
            {
                path: 'tag_group',
                name: 'wl_tag_group',
                component: TagGroupIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('tag_groups'),
                },
            },
            {
                path: 'tag_group/:id',
                name: 'wl_tag_group_edit',
                component: TagGroupEdit,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('tag_group'),
                },
            },
            {
                path: 'tag',
                name: 'wl_tag',
                component: TagIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('tags'),
                },
            },
            {
                path: 'tag/:id',
                name: 'wl_tag_edit',
                component: TagEdit,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('tag'),
                },
            },
            {
                path: 'genre_group',
                name: 'wl_genre_group',
                component: GenreGroupIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('rubriken'),
                },
            },
            {
                path: 'genre_group/:id',
                name: 'wl_genre_group_edit',
                component: GenreGroupEdit,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('rubrik'),
                },
            },
            {
                path: 'eventfrog_rubric',
                name: 'wl_eventfrog_rubric',
                component: EventfrogRubricIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('eventfrog_rubriken'),
                },
            },
            {
                path: 'organizer_group',
                name: 'wl_organizer_group',
                component: OrganizerGroupIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('kulturverbund'),
                },
            },
            {
                path: 'organizer_group/:id',
                name: 'wl_organizer_group_edit',
                component: OrganizerGroupEdit,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('kulturverbund'),
                },
            },
            {
                path: 'category',
                name: 'wl_category',
                component: CategoryIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('kategorien'),
                },
            },
            {
                path: 'weblink',
                name: 'wl_weblink',
                component: WeblinkIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN, ROLES.EDITOR, ROLES.MANAGER],
                    title: () => getI18nInstance().t('weblinks'),
                },
            },
            {
                path: 'region',
                name: 'wl_region',
                component: RegionIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('regionen'),
                },
            },
            {
                path: 'region/:id',
                name: 'wl_region_edit',
                component: RegionEdit,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('region'),
                },
            },
            {
                path: 'zip',
                name: 'wl_zip',
                component: ZipIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('orte'),
                },
            },
            {
                path: 'zip/:id',
                name: 'wl_zip_edit',
                component: ZipEdit,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('ort'),
                },
            },
            {
                path: 'dossier',
                name: 'wl_dossier',
                component: DossierIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('dossier'),
                },
            },
            {
                path: 'schedule_status',
                name: 'wl_schedule_status',
                component: ScheduleStatusIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('schedule_status'),
                },
            },
            {
                path: 'target_audience',
                name: 'wl_target_audience',
                component: TargetAudienceIndex,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.ADMIN],
                    title: () => getI18nInstance().t('target_audience'),
                },
            },
        ],
    },
];
